var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "splash" }, [
    _vm.loading ? _c("div", { staticClass: "labs-loader" }) : _vm._e(),
    _vm._m(0),
    _c(
      "button",
      {
        staticClass: "button button-outline splash-button button-medium",
        on: {
          click: function ($event) {
            return _vm.signIn()
          },
        },
      },
      [_vm._v(" Sign in ")]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "logo-block" }, [
      _c("span", { staticClass: "icon-folder-settings" }),
      _c("h1", [_vm._v("Refinitiv Trade Discovery")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }